import styled, { css } from 'styled-components';

const SliderContainer = styled.div<any>`
  display: grid;
  align-items: baseline;

  ${(props) =>
    props.numberInput &&
    css`
      grid-template-columns: 1fr 100px;
      grid-column-gap: 16px;
    `}
`;

export default SliderContainer;
